(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define('uuid',[], factory);
    } else if (typeof exports === 'object') {
        module.exports = factory();
    }
}(this, function () {
    /**
     *
     * @returns {string} A RFC 4122 Version 4 compliant UUID
     */
    function uuid4() {
        // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    function machineId(localStorage) {
        var key = 'g2.mid';

        var mid;

        if (localStorage) {
            try {
                mid = localStorage.getItem(key);
            } catch (e) {
                console.warn(e);
            }
        }

        if (!mid || mid.length != 20) {
            mid = uuid4().split('-').slice(0, 4).join('');

            if (localStorage) {
                try {
                    localStorage.setItem(key, mid);
                } catch (e) {
                    console.warn(e);
                }
            }
        }

        return mid;
    }

    function UUID(localStorage) {
        function uuid() {
            return uuid4();
        }

        uuid.constructor = UUID;

        uuid.uuid = uuid4();
        uuid.machineId = machineId(localStorage);

        return uuid;
    }

    return new UUID(typeof localStorage == 'undefined' ? undefined : localStorage);
}));

